// extracted by mini-css-extract-plugin
export default {"AddPublicKeySection__heading":"AddPublicKeySection_AddPublicKeySection__heading__j5CC4","AddPublicKeySection__body":"AddPublicKeySection_AddPublicKeySection__body__kwoYI"};